import { Navigate, useLocation } from "react-router-dom";

function ProtectedRoute({ isAuthenticated, children }) {
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }} // 🔥 ESTO ES CLAVE
        replace
      />
    );
  }

  return children;
}

export default ProtectedRoute;